import { createOnlineStoresBiLogger } from './bi.utils';
import { CheckoutService } from './CheckoutService';
import { SiteStore } from '../site-store/SiteStore';
import { createExports } from './Exports/createExports';
export function createViewerScript() {
    var context = {};
    return {
        initAppForPage: function (initParams, _apis, wixAPI, platformServices) {
            context.wixAPI = wixAPI;
            context.experiments = platformServices.essentials.experiments;
            context.errorHandler = platformServices.essentials.errorHandler;
            context.httpClient = platformServices.essentials.httpClient;
            context.initParams = initParams;
            context.checkoutService = new CheckoutService(context);
            context.biLogger = createOnlineStoresBiLogger(wixAPI, platformServices);
            context.trackEvent = wixAPI.window.trackEvent;
            context.siteStore = new SiteStore(initParams, _apis, wixAPI, platformServices);
            return Promise.resolve();
        },
        createControllers: function () { return null; },
        exports: createExports({ context: context, origin: 'wixcode' }),
    };
}
//# sourceMappingURL=viewerScript.js.map